import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditWarehouseComponent = loadable(
  () => import("../../components/Warehouse/EditWareHouse")
);
const EditWarehouse = () => {
  const { id } = useParams();

  const { refetch } = useGetHook({
    queryKey: [`warehouse-${id}`],
    url: `${APIS.WAREHOUSE}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`warehouse-${id}`],
    navigateURL: "/warehouse",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.WAREHOUSE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Warehouse
        </span>
      </div>
      <EditWarehouseComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditWarehouse;
